import { useMemo, useState } from "react";

export const useStructureSlice = () => {
  const [selectedStructures, setSelectedStructures] = useState([]);
  const selectedStructure = useMemo(() => (selectedStructures.length === 1 ? selectedStructures[0] : null), [selectedStructures]);
  const selectedStructureId = useMemo(() => (selectedStructure ? selectedStructure.id : null), [selectedStructure]);
  return useMemo(() => ({ selectedStructures, setSelectedStructures, selectedStructure, selectedStructureId }), [selectedStructures, selectedStructure, selectedStructureId]);
};
